import { useMemo } from "react";
import type { LatLng } from "../types";
import { mappableSpaces } from "../utils/coords";

export function useMappableSpaces<S extends LatLng>(
  spaces: S[],
): {
  mappable: S[];
  noneMappable: boolean;
} {
  const mappable = useMemo(() => mappableSpaces(spaces), [spaces]);
  return {
    mappable,
    noneMappable: spaces.length > 0 && mappable.length === 0,
  };
}
